import type { WidgetDefinition } from '../WidgetDefinition';
import { faChartLine } from '@fortawesome/pro-duotone-svg-icons/faChartLine';
import type { TradingViewChartWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { DEFAULT_INTERVAL, DEFAULT_TIMEZONE } from 'src/routes/widgets/TradingViewChartWidget/constants';
import type { TradingViewChartWidgetViewModel } from 'src/store/types';

class TradingViewChartWidgetDefinition implements WidgetDefinition<
    TradingViewChartWidgetViewModel,
    TradingViewChartWidgetModel
> {
    type = 'tradingview-chart' as const;
    nameKey = 'widgets::tradingview-chart::name' as const;
    roles = ['widgets::tradingview-chart'];
    icon = faChartLine;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.5, w: 0.6, x: 0.2, y: 0.25 };

    toViewModel(widget: TradingViewChartWidgetModel): TradingViewChartWidgetViewModel {
        return {
            ...widget,
        };
    }

    toContractModel(widget: TradingViewChartWidgetViewModel): TradingViewChartWidgetModel {
        return {
            ...widget,
            interval: widget.interval || DEFAULT_INTERVAL,
            timezone: widget.timezone || DEFAULT_TIMEZONE,
        };
    }
}

export const tradingViewChartWidgetDefinition = new TradingViewChartWidgetDefinition();
